import { render, staticRenderFns } from "./SlideDeckViewer.vue?vue&type=template&id=7b450fc0"
import script from "./SlideDeckViewer.vue?vue&type=script&lang=ts"
export * from "./SlideDeckViewer.vue?vue&type=script&lang=ts"
import style0 from "./SlideDeckViewer.vue?vue&type=style&index=0&id=7b450fc0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports